var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "6.731%",
    y1: "93.485%",
    x2: "99.367%",
    y2: "13.294%",
    id: "instagram_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF543E",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C837AB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.6 1.685C.393 2.94.64 4.271.64 8.317c0 3.36-.586 6.728 2.482 7.521.958.247 9.447.247 10.404-.001 1.277-.33 2.316-1.366 2.458-3.173.02-.252.02-8.438 0-8.695C15.833 2.044 14.648.935 13.087.71c-.358-.051-.43-.067-2.265-.07C4.312.643 2.884.353 1.6 1.685z",
    fill: "url(#instagram_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.319 2.649c-2.324 0-4.531-.207-5.374 1.956-.348.894-.297 2.054-.297 3.716 0 1.458-.047 2.828.297 3.714.841 2.165 3.066 1.957 5.372 1.957 2.226 0 4.52.232 5.373-1.957.349-.902.298-2.045.298-3.714 0-2.216.122-3.646-.953-4.72-1.088-1.088-2.559-.952-4.719-.952h.003zM7.81 3.671c4.848-.008 5.465-.546 5.124 6.94-.12 2.647-2.137 2.357-4.615 2.357-4.518 0-4.648-.13-4.648-4.65 0-4.573.358-4.644 4.14-4.648v.001zm3.536.942a.68.68 0 100 1.36.68.68 0 000-1.36zm-3.027.795a2.912 2.912 0 100 5.825 2.912 2.912 0 000-5.825zm0 1.022c2.499 0 2.502 3.781 0 3.781-2.499 0-2.503-3.78 0-3.78z",
    fill: "#FFF"
  }))));
}

export default __webpack_public_path__ + "./fonts/instagram.bdad0cb1aa96fbf92f2b6f3b1bd12765.svg";
export { SvgInstagram as ReactComponent };